// 액션 타입 정의
const BUTTONS_RESET = 'BUTTONS_RESET';
const BTN_TEXT = 'BTN_TEXT';
const BTN_PRE_FONT_SIZE = 'BTN_PRE_FONT_SIZE';
const BTN_FONT_SIZE = 'BTN_FONT_SIZE';
const BTN_FONT_WEIGHT = 'BTN_FONT_WEIGHT';
const BTN_COLOR = 'BTN_COLOR';
const BTN_BG_COLOR = 'BTN_BG_COLOR';
const BTN_FONT_FAMILY = 'BTN_FONT_FAMILY';
const BTN_RADIUS = 'BTN_RADIUS';
const BTN_TEXT_ALIGN = 'BTN_TEXT_ALIGN';
const BTN_AGAIN = 'BTN_AGAIN';

// 액션 생섬함수 정의
export const buttonsReset = () => ({ type: BUTTONS_RESET });
export const editBtnText = value => ({
  type: BTN_TEXT,
  value
});
export const editBtnPreFontSize = value => ({
  type: BTN_PRE_FONT_SIZE,
  value
});
export const editBtnFontSize = value => ({
  type: BTN_FONT_SIZE,
  value
});
export const editBtnFontWeight = value => ({
  type: BTN_FONT_WEIGHT,
  value
});
export const editBtnColor = value => ({
  type: BTN_COLOR,
  value
});
export const editBtnBgColor = (r, g, b, a) => ({
  type: BTN_BG_COLOR,
  r,
  g,
  b,
  a
});
export const editBtnFontFamily = value => ({
  type: BTN_FONT_FAMILY,
  value
});
export const editBtnRadius = value => ({
  type: BTN_RADIUS,
  value
});
export const editBtnTextAlign = value => ({
  type: BTN_TEXT_ALIGN,
  value
});
export const editBtnAgain = value => ({
  type: BTN_AGAIN,
  value
});

// 초기상태 정의
const initialState = {
  btnText: {},
  btnPreFontSize: {},
  btnFontSize: {},
  btnFontWeight: {},
  btnColor: {},
  btnBgColorR: {},
  btnBgColorG: {},
  btnBgColorB: {},
  btnBgColorA: {},
  btnFontFamily: {},
  btnRadius: {},
  btnTextAlign: {},
  btnAgain: {}
};

// 리듀서 작성
export default function buttonsReducer(state = initialState, action) {
  switch (action.type) {
    case BUTTONS_RESET:
      return initialState;
    case BTN_TEXT:
      return {
        ...state,
        btnText: action.value
      };
    case BTN_PRE_FONT_SIZE:
      return {
        ...state,
        btnPreFontSize: action.value
      };
    case BTN_FONT_SIZE:
      return {
        ...state,
        btnFontSize: action.value
      };
    case BTN_FONT_WEIGHT:
      return {
        ...state,
        btnFontWeight: action.value
      };
    case BTN_COLOR:
      return {
        ...state,
        btnColor: action.value
      };
    case BTN_BG_COLOR:
      return {
        ...state,
        btnBgColorR: action.r,
        btnBgColorG: action.g,
        btnBgColorB: action.b,
        btnBgColorA: action.a
      };
    case BTN_FONT_FAMILY:
      return {
        ...state,
        btnFontFamily: action.value
      };
    case BTN_RADIUS:
      return {
        ...state,
        btnRadius: action.value
      };
    case BTN_TEXT_ALIGN:
      return {
        ...state,
        btnTextAlign: action.value
      };
    case BTN_AGAIN:
      return {
        ...state,
        btnAgain: action.value
      };
    default:
      return state;
  }
}
